import React, { useState, useEffect, useCallback, useMemo } from "react";
import { Select, Tabs, Table, Modal, Popover, Button, Spin } from "antd";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import images from "../../themes/appImage";
import appconstant from "../../themes/appconstant";

import { imageURL } from "../../redux/Api/apikit";
import {  renderPostContent } from "../../utils/global-func";
import { useFormik } from "formik";
import * as Yup from "yup";
import CreatePost from "./CreatePost";
import CreateUser from "./CreateUser";
import { engagementFarmingListLoad } from "../../redux/slices/engagementFarming.slice";
import moment from "moment";
import { dummyUserListLoad } from "../../redux/slices/createUser.slice";

const { TabPane } = Tabs;

const Engagementfarming = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [pagination, setPagination] = useState({ limit: 500, offset: 0 });
    const dummyUsers = useSelector(
      (state) => state.createUserReducer?.data?.data?.list || []
    );
  const { postList, postDashboard, postPagination, isLoading } = useSelector(
    (state) => state?.engagementFarmingReducer || {}
  );
  const [tab, setTab] = useState("1");

  const [payload, setPayload] = useState({
    limit: 10,
    offset: 0,
  });
  let OFFSET = 0
  const [currentPage, setCurrentPage] = useState(1);
  const [modalState, setModalState] = useState({
    approve: false,
    reject: false,
  });
  
  const [selectedPro, setSelectedPro] = useState(null);
   useEffect(() => {
      dispatch(dummyUserListLoad(pagination));
    }, [dispatch]);

  useEffect(() => {
    document.title = "MentalFit";
    dispatch(engagementFarmingListLoad(payload));
  }, [payload, dispatch]);

  const onChangePage = (page) => {
    if (
      page < 1 ||
      (postPagination &&
        page > Math.ceil(postPagination.totalCount / payload.limit))
    )
      return;
    setCurrentPage(page);
    setPayload((prev) => ({
      ...prev,
      offset: (page - 1) * prev.limit,
    }));
  };

  const onChangePageSize = (limit) => {
    setPayload((prev) => ({
      ...prev,
      limit: Number(limit),
      offset: 0,
    }));
    setCurrentPage(1);
  };

  const onUpdateStatus = (proId, status, reason = "") => {
    const statusPayload = { proId, status };
    if (reason) statusPayload.reason = reason;

    dispatch(engagementFarmingListLoad({ data: statusPayload, payload }));
    setModalState({ approve: false, reject: false });
    setSelectedPro(null);
  };
 console.log('   ', dummyUsers)
  const getColumns = useCallback(
    (tabKey) => {
      const commonColumns = [
        {
          title: "ID",
          dataIndex: "srno",
          key: "srno",

          render: (_, __, index) =>
            (postPagination?.currentPage - 1) * 10 + index + 1,
        },
        {
          title: "Posts",
          dataIndex: "posts",
          key: "posts",
          render: (_, record) => renderPostContent(record),
        },
        {
          title: "Creator",
          dataIndex: "creator",
          key: "creator",
          render: (_, record) => record.creatorData?.userName || "N/A",
        },
        {
          title: "Action",
          key: "action",
          render: (_, record) => (
            <div className="flex items-center justify-center">
              <img
                src={images.view}
                alt="reject"
                className="cursor-pointer w-5 h-5"
                onClick={() => navigate("/post", { state: record })}
              />
            </div>
          ),
        },
      ];

      return commonColumns;
    },
    [postPagination]
  );


   const columns = [
        {
            title: 'ID',
            dataIndex: 'srno',
            key: 'srno',
            sorter: false,
            render: (value, item, index) => (OFFSET + index + 1)
        },
        {
            title: 'Full Name',
            dataIndex: 'name',
            key: 'name',
            sorter: false,
            sortDirections: ['ascend', 'descend'],
            render: (value, item, index) => <div className="organization-image-sec">
                {item.avatar && <span><img className="w-6 h-6 rounded-[100%] object-contain" src={`${imageURL}${item?.avatar}`} /></span>}
                {item?.firstName}  {item.lastName}
            </div>
        },
        {
            title: 'Username',
            dataIndex: 'userName',
            key: 'userName',
            sorter: false,
        },
        {
            title: 'Gender',
            dataIndex: 'identityType',
            key: 'gender',
            sorter: false,
            sortDirections: ['ascend', 'descend'],
                 },
        {
            title: 'DOB',
            dataIndex: 'dob',
            key: 'dob',
            sorter: false,
            render: (value, item, index) =>
                <div className="table-tb-plan">
                    {item.dob ? moment(item.dob).format('MMMM D, YYYY') : "N/A"}
                </div>
        },
    ];


  const TableFooter = () => {
    // const totalCount = postPagination?.totalCount || 0;
    // const from = totalCount === 0 ? 0 : (currentPage - 1) * payload.limit + 1;
    // const to = Math.min(currentPage * payload.limit, totalCount);
    const totalCount = postPagination?.totalCount || postList?.length || 0;
    const from = totalCount === 0 ? 0 : (currentPage - 1) * payload.limit + 1;
    const to = Math.min(currentPage * payload.limit, totalCount);
    const totalPages = Math.ceil(totalCount / payload.limit);

    return (
      <div className="footer-section">
        <div className="foot-main-div">
          <div className="rows">
            <div className="row-per-page">
              <p>Rows per page</p>
            </div>
            <div className="top-checkbox fot-select">
              <Select
                value={String(payload.limit)}
                onChange={onChangePageSize}
                options={[
                  { value: "10", label: "10" },
                  { value: "15", label: "15" },
                  { value: "20", label: "20" },
                  { value: "25", label: "25" },
                ]}
              />
            </div>
          </div>
          <div className="page-count">
            <p>
              {from}-{to} of {totalCount}
            </p>
          </div>
          <div className="back-and-next">
            <span
              onClick={() => onChangePage(1)}
              style={{
                cursor: currentPage > 1 ? "pointer" : "not-allowed",
                opacity: currentPage > 1 ? 1 : 0.5,
              }}
            >
              <img src={images.next} className="rotate-180" alt="back" />
            </span>
            <span
              onClick={() => onChangePage(currentPage - 1)}
              style={{
                cursor: currentPage > 1 ? "pointer" : "not-allowed",
                opacity: currentPage > 1 ? 1 : 0.5,
              }}
            >
              <img src={images.new} className="rotate-180" alt="previous" />
            </span>
            <span
              onClick={() => onChangePage(currentPage + 1)}
              style={{
                cursor: currentPage < totalPages ? "pointer" : "not-allowed",
                opacity: currentPage < totalPages ? 1 : 0.5,
              }}
            >
              <img src={images.new} alt="next" />
            </span>
            <span
              onClick={() => onChangePage(totalPages)}
              style={{
                cursor: currentPage < totalPages ? "pointer" : "not-allowed",
                opacity: currentPage < totalPages ? 1 : 0.5,
              }}
            >
              <img src={images.next} alt="last" />
            </span>
          </div>
        </div>
      </div>
    );
  };

  const ApproveModal = ({ visible, onClose, onApprove }) => (
    <Modal
      title=""
      className="modal-update"
      centered
      open={visible}
      onCancel={onClose}
      footer={null}
      width={600}
    >
      <div className="add-user-popup">
        <div className="modal-add-user modal-top-space-ps">
          <h1>Do you surely want to approve?</h1>
        </div>
        <div className="schedule-send-now">
          <div className="send-now option-no">
            <button onClick={onClose}>No</button>
          </div>
          <div className="btn-schedule">
            <button onClick={onApprove}>Approve</button>
          </div>
        </div>
      </div>
    </Modal>
  );

  const RejectModal = React.memo(({ visible, onClose, onReject }) => {
    const onSubmit = (values) => {
      onUpdateStatus(
        selectedPro?.user || selectedPro?.id,
        "rejected",
        values?.rejectReason
      );
    };

    const rejectFormik = useFormik({
      initialValues: {
        rejectReason: "",
      },

      validationSchema: Yup.object({
        rejectReason: Yup.string()
          .min(3, "Reason must be at least 3 characters long.")
          .max(250, "Reason cannot exceed 250 characters.")
          .required("Please enter reason for rejection."),
      }),
      onSubmit,
    });

    return (
      <Modal
        title=""
        className="modal-update"
        centered
        open={visible}
        onCancel={onClose}
        footer={null}
        width={600}
      >
        <div className="add-user-popup">
          <div className="modal-add-user">
            <h1>Reject Pro Request</h1>
          </div>
          <form onSubmit={rejectFormik.handleSubmit}>
            <div className="description-inner-circle">
              <div className="wrapper_line">
                <div className="form-group">
                  <div className="textarea-label">
                    <label>{appconstant.rejectionReason}</label>
                    <p>{rejectFormik.values.rejectReason.length}/100</p>
                  </div>
                  <textarea
                    rows="5"
                    cols="50"
                    className="form-control-textarea"
                    placeholder="Add Reason"
                    name={"rejectReason"}
                    maxLength={100}
                    value={rejectFormik.values.rejectReason}
                    onChange={rejectFormik.handleChange}
                    onBlur={rejectFormik.handleBlur}
                  />

                  {rejectFormik?.errors?.rejectReason &&
                    rejectFormik?.touched?.rejectReason && (
                      <p className="text-red-600">
                        {rejectFormik?.errors?.rejectReason}
                      </p>
                    )}
                </div>
              </div>
            </div>
            <div className="click-to-upload">
              <div className="create-inner-circle-btn save-btn-mo">
                <button
                  type="submit"
                  disabled={
                    rejectFormik.values.rejectReason.trim().length === 0
                  }
                >
                  Save
                </button>
              </div>
            </div>
          </form>
        </div>
      </Modal>
    );
  });

  const handleViewCertificates = (url) => {
    window.open(url, "_blank");
  };

  return (
    <div className="site-layout-background">
      <div className="top-header-organi-zations">
        <div className="organi-zations-heading-text">
          <h1>App Engagement</h1>
          {/* <p>
            Sed consectetur imperdiet facilisiulla malesua daeddiet facilisiulla
          </p> */}
        </div>
      </div>
      {console.log(tab, "thistab")}
      <section>
        <div className="slider-section manage-table-data">
          <div className="slider-tab-div">
            <Tabs
              activeKey={tab}
              onChange={(key) => {
                console.log("Active", key);
                setTab(key);
              }}
              destroyInactiveTabPane
            >
              {[
                { key: "1", label: "All Posts" },
                { key: "2", label: "Dummy Users" },
                { key: "3", label: "Create Post" },
                { key: "4", label: "Create User" },
              ].map(({ key, label }) => (
                <TabPane tab={label} key={key}>
                  {tab === "1" && (
                    <>
                      <Table
                        dataSource={postList}
                        columns={getColumns(key)}
                        pagination={false}
                        rowKey={(record) => record._id || record.id}
                        showSorterTooltip={false}
                      />
                      <TableFooter />
                    </>
                  )}
                  {tab === "2" && (
                    <>
                    <div className="content-e">
                    <Table
                        dataSource={dummyUsers}
                        columns={columns}
                        showSorterTooltip={false}
                        pagination={{
                            current: 0,
                            pageSize: 0,
                            total: 500,
                        }}
                    />
                    </div>
                    </>
                  )}

                    {/* {TOTAL_LIST_ITEMS > 10 && <div className="footer-section">
                        <div className="foot-main-div">
                            <div className="rows">
                                <div className="row-per-page">
                                    <p>Rows per page</p>
                                </div>

                            </div> 

                            <div className="page-count">
                                <p>{`${START}-${END} of ${TOTAL_LIST_ITEMS}`}</p>
                            </div>

                            <div className="back-and-next">
                                <span onClick={() => OFFSET !== 0 && paginationHandler("pre")}><img src={OFFSET == 0 ? images.per : images.paginationDimLeft} style={{ tintColor: "red" }} alt="back" /></span>
                                <span onClick={() => canCallNextData && paginationHandler("next")}><img src={canCallNextData == false ? images.paginationDimRight : images.new} alt="back" /></span>
                            </div> 

                           </div>

                         </div>}
                      </div>
                    </>
                  )} */}



                  {tab === "3" && <CreatePost />}

                  {tab === "4" && <CreateUser setTab={setTab} />}
                </TabPane>
              ))}
            </Tabs>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Engagementfarming;
